import { COUPON_SERVICE_APIS } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { setPincodeListing } from "@/app_redux/reducers/slices/auth/coupon_service_slice";
import { ICouponPincodeListingResponse } from "@/api_framework/api_modals/coupon";

AxiosCurlirize(axios, () => {});

export const usePincodeListingAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async () => {
      dispatch(
        setLoading({
          key: "isInventoryServiceListLoadingInProgess",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const res: AxiosResponse<ICouponPincodeListingResponse> = await axios.get(
          `${COUPON_SERVICE_APIS?.PINCODE_LISTING?.baseURL}/`,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );
        if (res.data.status === true) {
          dispatch(setPincodeListing({ data: res?.data.data }));
        } else {
          dispatch(setPincodeListing({ data: [] }));
        }
        dispatch(
          setLoading({
            key: "isInventoryServiceListLoadingInProgess",
            status: false,
          }),
        );
      } catch (error) {
        dispatch(setPincodeListing({ data: [] }));

        dispatch(
          setLoading({
            key: "isInventoryServiceListLoadingInProgess",
            status: false,
          }),
        );
        if (axios.isAxiosError(error)) {
          captureError(error);
          if (error.config) {
            sendCurl(error.config["curlCommand"]);
          }
        } else {
          toast.error("Server Error: " + (error as Error).message);
        }
      }
    },
    [dispatch, configuration, sendCurl, captureError],
  );
  return { execute };
};
